import { React, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Grid,
  Box,
  Paper,
  useMediaQuery,
  Button,
  TextField,
} from '@material-ui/core';
import { ROUTES } from '../../../../constants/routes';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { commercialPageConstants } from '../../../../constants';
import { isUndefined } from 'lodash';
import { userActions } from '../../../../redux/actions';

export default function SectionThree(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('md'));
  const isMobileSmall = useMediaQuery(theme.breakpoints.up('md'));
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      fontFamily: 'Raleway',
    },
    sectionOne: {
      backgroundColor: 'white',
      paddingLeft: 20,
      paddingRight: 20,
      fontSize: '1.2rem',
      color: 'black',
      marginTop: '50px'

    },
    sectionOneMobile: {
      backgroundColor: 'white',
      fontSize: '.9rem',
      color: 'black',
      marginTop: '50px'

    },
    innerGridContainer: {
      width: "100%",
      margin: "0px",
      padding: "30px"
    },
    innerGridSmallHeading: {
      width: "100%",
      textAlign: "left",
      fontSize: "1rem",
      fontWeight: "bold"
    },
    innerGridHeading: {
      width: "100%",
      textAlign: "left",
      fontSize: "3rem",
      fontFamily: "sans-serif"
    },
    sectionParagraph: {
      // margin: "10px 0px",
      textAlign: "left",
      fontSize: ".6rem",
      marginTop: '0px',
      fontWeight: 'bold'
    },
    sectionParagraphNoMarginTop: {
      // margin: "10px 0px",
      textAlign: "left",
      fontSize: ".6rem",
      marginTop: '-10px',
      fontWeight: 'bold'
    },
    sectionParagraphBold: {
      // margin: "10px 0px",
      textAlign: "left",
      fontSize: ".8rem",
      marginTop: '0px',
      fontWeight: 'bold'
    },
    media: {
      maxHeight: 300,
      maxWidth: 700,
      minHeight: 300,
      float: 'right',
      width: '100%'
    },
    actionButtonModal: {
      backgroundColor: "#ef6c00",
      border: "2px solid #ef6c00",
      color: "#FFF",
      textDecoration: "none",
      padding: "10px",
      fontWeight: "bold",
      fontSize: ".5rem",
      cursor: "pointer",
      "&:hover": {
        color: "#000",
      },
      width: '100px',
      height: '30px',
      marginTop: '30px'
    },
    
  multilineTextArea: {
    width: '100%',
  },
  }));

  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [contactSalesInputs, setContactSalesInputs] = useState({
    contactSalesEmail: '',
    contactSalesFirstName: '',
    contactSalesLastName: '',
    contactSalesCompany: '',
    contactSalesMessage: ''
  });
  const {
    contactSalesEmail,
    contactSalesFirstName,
    contactSalesLastName,
    contactSalesCompany,
    contactSalesMessage
  } = contactSalesInputs;


  const handleChangeContactSales = (event) => {
    const { name, value } = event.target;
    setContactSalesInputs(inputs => ({ ...inputs, [name]: value }));
  }

  const handleContactSalesSubmit = (event) => {
    event.preventDefault();

    if (!isUndefined(contactSalesEmail) &&
      !isUndefined(contactSalesFirstName) &&
      !isUndefined(contactSalesLastName) &&
      !isUndefined(contactSalesCompany) &&
      !isUndefined(contactSalesMessage)
    ) {
      const payload = {
        email: contactSalesEmail,
        first_name: contactSalesFirstName,
        last_name: contactSalesLastName,
        company: contactSalesCompany,
        message: contactSalesMessage,
        inquiry: event.currentTarget[5].name
      }

      dispatch(userActions.contactSales(payload));
      // setOpenContactUsModal(false);
    }
  }

  return (
    <div className={classes.root}>
      <section className={isMobile ? classes.sectionOne : classes.sectionOneMobile}>
        <Grid container>
          <Grid item xs={2}></Grid>
          <Grid item xs={7} className={classes.innerGridContainer} container spacing={2}>
            {/* <h5 className={classes.innerGridSmallHeading}>Lorem ipsum dolor</h5> */}
            <h5 className={classes.innerGridHeading}>
              <Grid item xs={6} container>
                <p style={{ fontWeight: "lighter", textAlign: 'left', fontSize: '30px' }}>
                  Dit branddesign begynder her
                </p>
              </Grid>
            </h5>
            {/* <Grid container direction="row" justify="left" alignItems="left"> */}
            <Grid>
              <Grid style={{ marginTop: '5px' }}>
                <p className={classes.sectionParagraph}>
                  Book en presentation. Fortael om dine onsker
                </p>
              </Grid>
              <Grid container style={{ marginTop: '40px' }}>
                <Grid xs={5}>
                  <p className={classes.sectionParagraph}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur in est vel nulla varius aliquet aliquet ac ante. Ut nibh urna, posuere et risus vel, sagittis interdum diam. Nulla vitae luctus metus. Nulla vulputate eros eu purus congue, id blandit ante fringilla.
                  </p>
                  <Grid container>
                    <Grid>
                      <p className={classes.sectionParagraphBold}>
                        Addresse
                      </p>
                      <p className={classes.sectionParagraphNoMarginTop}>
                        Amalievej 6, downunder
                      </p>
                      <p className={classes.sectionParagraphNoMarginTop}>
                        1875 Frederiksberf C
                      </p>
                    </Grid>
                    <Grid xs={3}></Grid>
                    <Grid>
                      <p className={classes.sectionParagraphBold}>
                        kontakt
                      </p>
                      <p className={classes.sectionParagraphNoMarginTop}>
                        +45 70 60 59 49
                      </p>
                      <p className={classes.sectionParagraphNoMarginTop}>
                        kontakt@instorex.dk
                      </p>
                      <p className={classes.sectionParagraphBold}>
                        kontakt
                      </p>
                      <p className={classes.sectionParagraphNoMarginTop}>
                        +45 70 60 59 49
                      </p>
                      <p className={classes.sectionParagraphNoMarginTop}>
                        kontakt@instorex.dk
                      </p>
                    </Grid>
                  </Grid>

                </Grid>
                <Grid xs={1}>

                </Grid>
                <Grid xs={6} style={{ marginTop: '-30px' }}>
                  <form onSubmit={handleContactSalesSubmit}>
                    <TextField
                      className="credentials-input-field"
                      type="text"
                      id="email"
                      name="contactSalesEmail"
                      placeholder="Work Email"
                      fullWidth
                      margin="normal"
                      autoFocus
                      value={contactSalesEmail}
                      onChange={handleChangeContactSales}
                    />
                    <TextField
                      className="credentials-input-field"
                      type="text"
                      id="firstName"
                      name="contactSalesFirstName"
                      placeholder="First Name"
                      fullWidth
                      margin="normal"
                      autoFocus
                      value={contactSalesFirstName}
                      onChange={handleChangeContactSales}
                    />
                    <TextField
                      className="credentials-input-field"
                      type="text"
                      id="lastName"
                      name="contactSalesLastName"
                      placeholder="Last Name"
                      fullWidth
                      margin="normal"
                      autoFocus
                      value={contactSalesLastName}
                      onChange={handleChangeContactSales}
                    />
                    <TextField
                      className="credentials-input-field"
                      type="text"
                      id="company"
                      name="contactSalesCompany"
                      placeholder="Company"
                      fullWidth
                      margin="normal"
                      autoFocus
                      value={contactSalesCompany}
                      onChange={handleChangeContactSales}
                    />
                    <TextField
                      id="standard-multiline-static"
                      name="contactSalesMessage"
                      className={classes.multilineTextArea}
                      multiline
                      rows={8}
                      placeholder="Message"
                      value={contactSalesMessage}
                      onChange={handleChangeContactSales}
                    />
                    <Button type="submit" name="sales" className={classes.actionButtonModal}>Send</Button>
                  </form>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </section >
    </div >
  )
}